// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3rBad","buttons":"RemoveExpirationActionButtons_buttons__35cyD"};